<template>
  <div class="rd-screen">
    <report-tools :copy="groups.length > 0" @copy="copyOrders"></report-tools>

    <report-state v-if="loading" kind="loading"></report-state>
    <report-state
      v-else-if="!groups.length"
      icon="mdi-grid"
      :title="emptyTitle"
      :text="emptyText"
    ></report-state>

    <template v-else>
      <section v-for="group in groups" :key="group.id" class="rd-slips">
        <div class="rd-slips__head">
          <report-shift-tag :shift="group.id" long></report-shift-tag>
          <i class="rd-order-card__rule"></i>
          <span class="rd-num">{{ groupSummary(group) }}</span>
        </div>

        <div class="rd-slips__grid">
          <article v-for="slip in group.slips" :key="slip.key" class="rd-slip" :data-shift="group.id">
            <header class="rd-slip__head">
              <span class="ui-avatar ui-avatar--neutral ui-avatar--sm">{{ slip.initials }}</span>
              <b class="rd-slip__name" :title="`ID ${slip.id}`">{{ slip.name }}</b>
              <span v-if="slip.orderId && !isRange" class="rd-slip__no rd-num">#{{ slip.orderId }}</span>
            </header>
            <ul>
              <li v-for="(meal, index) in slip.meals" :key="index">
                <b class="rd-num">{{ meal.total }}× </b>
                <span>{{ meal.name }}</span>
              </li>
            </ul>
          </article>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import CompanyReportTabOrders from "@/components/company/reports/companyTabs/companyReportTabOrders.vue";
import hasShiftSubtitle from "@/components/report/shared/hasShiftSubtitle";
import ReportShiftTag from "@/components/report/shared/ReportShiftTag.vue";
import { copyText, rowsToTsv } from "@/components/report/desktop/copyTable";
import ReportState from "@/components/report/desktop/ReportState.vue";
import ReportTools from "@/components/report/desktop/ReportTools.vue";
import hasCompanyOrderSlips from "../../hasCompanyOrderSlips";

const SHIFT_NAMES = { 1: "one", 2: "two", 3: "three", 4: "four" };

/**
 * Naručeno firme na računaru: po smenama kartice radnika sa njihovim obrocima (kao porudžbenica). Smene, firme,
 * period i pretragu (po imenu radnika) čita iz zajedničke trake. Nasleđuje učitavanje, štampu i Excel iz starog
 * taba; podela po smenama je u hasCompanyOrderSlips.
 */
export default {
  name: "CompanyDesktopOrdered",
  extends: CompanyReportTabOrders,
  mixins: [hasCompanyOrderSlips, hasShiftSubtitle],
  components: { ReportShiftTag, ReportState, ReportTools },
  computed: {
    emptyTitle() {
      return this.search
        ? this.$t("report_mobile.no_results_for", { search: this.search })
        : this.$t("no_orders");
    },
    emptyText() {
      return this.search ? "" : this.$t("report_desktop.empty_hint");
    },
    kpis() {
      return [
        { key: "workers", label: this.$t("report_desktop.workers"), value: this.workerTotal, tone: "inverse" },
        { key: "meals", label: this.$t("report_desktop.total_meals"), value: this.mealTotal },
      ];
    },
  },
  watch: {
    kpis: {
      handler(kpis) {
        this.$emit("kpis", this.groups.length ? kpis : []);
      },
      immediate: true,
    },
    loading: {
      handler(loading) {
        this.$emit("loading", loading);
      },
      immediate: true,
    },
  },
  methods: {
    async copyOrders() {
      const headers = [this.$t("shifts"), this.$t("worker"), "#", this.$t("meals")];
      const rows = this.groups.flatMap((group) =>
        group.slips.map((slip) => [
          this.$t(`shift.${SHIFT_NAMES[group.id]}`),
          slip.name,
          slip.orderId,
          slip.meals.map((meal) => `${meal.total}× ${meal.name}`).join("; "),
        ])
      );
      const copied = await copyText(rowsToTsv(headers, rows));
      this.$emit("toast", this.$t(copied ? "report_desktop.copied" : "report_desktop.copy_failed"));
    },
  },
};
</script>
